"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationWireV1 = exports.ObfuscatedPrecomputedConfigurationResponse = exports.PrecomputedConfigurationResponse = exports.PrecomputedConfiguration = void 0;
const interfaces_1 = require("./interfaces");
const obfuscation_1 = require("./obfuscation");
// Base class for configuration responses with common fields
class BasePrecomputedConfigurationResponse {
    constructor(subjectKey, subjectAttributes, environment) {
        this.subjectKey = subjectKey;
        this.subjectAttributes = subjectAttributes;
        this.environment = environment;
        this.format = interfaces_1.FormatEnum.PRECOMPUTED;
        this.createdAt = new Date().toISOString();
    }
}
class PrecomputedConfiguration {
    constructor(response, subjectKey, subjectAttributes) {
        this.response = response;
        this.subjectKey = subjectKey;
        this.subjectAttributes = subjectAttributes;
    }
    static obfuscated(subjectKey, flags, bandits, salt, subjectAttributes, environment) {
        const response = new ObfuscatedPrecomputedConfigurationResponse(subjectKey, flags, bandits, salt, subjectAttributes, environment);
        return new PrecomputedConfiguration(JSON.stringify(response), subjectKey, subjectAttributes);
    }
    static unobfuscated(subjectKey, flags, bandits, subjectAttributes, environment) {
        const response = new PrecomputedConfigurationResponse(subjectKey, flags, bandits, subjectAttributes, environment);
        return new PrecomputedConfiguration(JSON.stringify(response), subjectKey, subjectAttributes);
    }
}
exports.PrecomputedConfiguration = PrecomputedConfiguration;
class PrecomputedConfigurationResponse extends BasePrecomputedConfigurationResponse {
    constructor(subjectKey, flags, bandits, subjectAttributes, environment) {
        super(subjectKey, subjectAttributes, environment);
        this.flags = flags;
        this.bandits = bandits;
        this.obfuscated = false;
    }
}
exports.PrecomputedConfigurationResponse = PrecomputedConfigurationResponse;
class ObfuscatedPrecomputedConfigurationResponse extends BasePrecomputedConfigurationResponse {
    constructor(subjectKey, flags, bandits, salt, subjectAttributes, environment) {
        super(subjectKey, subjectAttributes, environment);
        this.obfuscated = true;
        this.salt = salt;
        this.bandits = (0, obfuscation_1.obfuscatePrecomputedBanditMap)(this.salt, bandits);
        this.flags = (0, obfuscation_1.obfuscatePrecomputedFlags)(this.salt, flags);
    }
}
exports.ObfuscatedPrecomputedConfigurationResponse = ObfuscatedPrecomputedConfigurationResponse;
class ConfigurationWireV1 {
    constructor(precomputed) {
        this.precomputed = precomputed;
        this.version = 1;
    }
}
exports.ConfigurationWireV1 = ConfigurationWireV1;
//# sourceMappingURL=configuration-wire-types.js.map